import styled from "styled-components";

export const Container = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	padding: 20px;

	h2{
		font-family: "Roboto";
	}

	button{
		background: #2d7bbc;
		border: none;
		color: white;
				box-sizing: border-box;
				padding: 1rem 3rem;
				cursor: pointer;
				margin-top: 1rem;

				/* padding: 1rem 3rem; */

				border-radius: 0.25rem;

				text-transform: uppercase;

				transition: all 0.3s;

				font-size: 1.25rem;
				font-weight: 700;
	}
`;

export const Content = styled.div`
	max-width: 50rem;
	overflow: scroll;
	padding-right: 10px;


`;

export const QuestionContainer = styled.div`
	width: 100%;
	margin-top: 20px;
	display: flex;
	gap: 10px;
	flex-direction: column;
	padding: 5px;
`;